import React from 'react';
import cn from 'classnames';
import { Field } from '../../../../../shared/components/Form';
import { FieldProps } from '../../../../../shared/components/Form/Field';

export const WizardCheckbox = ({ checked, fieldClassName, className, ...props }: FieldProps<any>) => {
    return (
        <Field.Checkbox
            {...props}
            checked={checked}
            fieldClassName={cn('field--no-height', fieldClassName)}
            className={cn('view__user_panel__checkbox', checked ? 'bg-blue text-white' : 'bg-grey-light', className)}
        />
    );
};
